const SESSION_EXPIRED_EVENT = "session:expired";

export const emitSessionExpired = (): void => {
  window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
};

export const onSessionExpired = (callback: () => void): void => {
  window.addEventListener(SESSION_EXPIRED_EVENT, callback);
};

export const offSessionExpired = (callback: () => void): void => {
  window.removeEventListener(SESSION_EXPIRED_EVENT, callback);
};
